<template>
  <v-card>
    <v-card-title class="headline py-2">
      Информация об объекте учета
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p class="subheading">{{cardObject.name}}</p>
      <p v-if="cardObject.unit"><span class="body-2">Ед. измерения: </span>{{cardObject.unit}}</p>
      <div v-if="cardObject.description" v-html="cardObject.description"></div>
      
      <p class="body-2 mb-1">Признаки объекта учета</p>
      <v-data-table :items="cardObject.properties" hide-headers hide-actions no-data-text="Данные отсутствуют" class="obj-props-table">
        <template slot="items" slot-scope="{item, index}">
          <td><v-icon size="16">{{getIcon(item.element_type)}}</v-icon> {{item.name}}</td>
        </template>
      </v-data-table>
      
    </v-card-text>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  
  export default {
    name : "InfoObjectForm",
  
    mixins: [entities],
    
    props : {
      data : {
        type : Object,
        required : false,
        default : () => {
          return {}
        }
      }
    },
   
    created(){
      this.$store.dispatch('analytics/constructor/getObject', this.data.id).then( response => {
        this.cardObject = response
        this.convertArrayobjects(this.cardObject.properties)
      })
    },
    
    data() {
      return {
        cardObject: {},
      }
    },
    
    methods : {
      getIcon(type){
        switch(type){
          case 'post': return 'mdi-account'; break;
          case 'container': return 'mdi-account-group'; break;
          default: return 'mdi-rhombus-medium'
        }
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/InfoObjectForm.vue